<ng-container *ngIf="!(!currentStatusToggle && action && action['name'] === terminal.status.name)">
  <div class="contextual-action">
    <!-- <button
    [nbSpinner]="awaitTerminalActionComplete"
    nbSpinnerStatus="info"
    nbSpinnerSize="large"
    nbButton
    class="contextual-action-button"
    (click)="setAction(terminalId, action['type'])"
  >
    {{ action['name'] }}
  </button> -->
    <span *ngIf="currentStatusToggle" class="current-status">{{ terminal.status.name }}</span>
    <nb-toggle
      *ngIf="!action"
      checked=true
      disabled=true
    ></nb-toggle>
    <span *ngIf="!currentStatusToggle && action">{{ action['name'] }}</span>
    <nb-toggle
      (click)="setAction(terminal.id, action['type'])"
      *ngIf="action"
      [(checked)]="checked || actionInProgress"
      [nbSpinner]="awaitTerminalActionComplete"
      disabled="disableToggleClick"
      nbSpinnerSize="large"
      nbSpinnerStatus="info"
    ></nb-toggle>
  </div>
</ng-container>
